import type { IContentPage } from '~/lib/ContentfulService';

/**
 * Global state for tracking current page for analytics purposes
 * This allows the analytics plugin to access page topic data
 */
export const useCurrentPageState = () => {
  return useState<IContentPage | null>('currentPageForAnalytics', () => null);
};

/**
 * Global state for English topic slugs mapping.
 * Used by the analytics plugin to access English topic slugs.
 */
export const useTopicSlugMapEn = () => {
  return useState<Record<string, string>>('topicSlugMapEn', () => ({}));
};

/**
 * Sets the current page and topic slug map for analytics tracking
 * Should be called from page components when page data is available
 *
 * @param page - The current ContentPage
 * @param topicSlugMapEn - Mapping of topic IDs to English slugs
 */
export function setCurrentPageForAnalytics(
  page: IContentPage | null,
  topicSlugMapEn: Record<string, string> = {}
) {
  const currentPageState = useCurrentPageState();
  const topicSlugMapEnState = useTopicSlugMapEn();

  currentPageState.value = page;
  topicSlugMapEnState.value = topicSlugMapEn;
}
